<template>
  <!-- name: '捐衣篮' -->
  <div class="backetWrap">
    <div class="nameClass">捐赠篮</div>
    <SelectTab
      :selectTabList="['捐衣', '捐物']"
      :curSelectTab="curSelectTab"
      @selectTab="selectTab"
    />
    <div class="listBox" v-if="curSelectTab === '捐衣'">
      <ul>
        <li v-for="(item, index) in clothesList" :key="index">
          <h5>
            <input
              type="checkbox"
              class="checkboxClass"
              :checked="item.isCheck"
              @click="checkLiClothesClick(index)"
            />
            <span>{{ item.theme }}</span
            ><img
              src="https://img.bbalt.cn/imgh5/donate/icon_narrow_right.svg"
              alt=""
            />
          </h5>
          <table>
            <tr v-for="(subItem, subIndex) in item.details" :key="subIndex">
              <td>
                <input
                  type="checkbox"
                  class="checkboxClass"
                  :checked="subItem.isCheck"
                  @click="checkClothesClick(index, subIndex)"
                />
              </td>
              <td>{{ subItem.sizeHeightName }}</td>
              <td>{{ subItem.sexName }}</td>
              <td>{{ subItem.seasonName }}</td>
              <td class="countBox">
                <img
                  :src="`https://img.bbalt.cn/imgh5/donate/icon_minus${
                    subItem.donateCount === 0 ? '' : '_act'
                  }.svg`"
                  alt=""
                  @click="
                    () => {
                      subItem.donateCount--;
                      handleCount(
                        index,
                        subIndex,
                        subItem.donateCount,
                        subItem.insufficiency
                      );
                      updateLocalStorage();
                    }
                  "
                />
                <input
                  type="tel"
                  class="numberboxClass"
                  v-model="subItem.donateCount"
                  @mousedown="
                    donateCount = subItem.donateCount;
                    updateLocalStorage();
                  "
                  :disabled="subItem.insufficiency === 0"
                  @change="
                    handleCount(
                      index,
                      subIndex,
                      subItem.donateCount,
                      subItem.insufficiency
                    )
                  "
                />
                <img
                  :src="`https://img.bbalt.cn/imgh5/donate/icon_add${
                    subItem.insufficiency === 0 ? '' : '_act'
                  }.svg`"
                  alt=""
                  @click="
                    subItem.donateCount++;
                    updateLocalStorage();
                    handleCount(
                      index,
                      subIndex,
                      subItem.donateCount,
                      subItem.insufficiency
                    );
                  "
                  :disabled="subItem.insufficiency === 0"
                  :class="subItem.insufficiency === 0 ? 'img-onlyRead' : ''"
                />
              </td>
              <td>
                <img
                  src="https://img.bbalt.cn/imgh5/userCenter/icon_delete.svg"
                  alt=""
                  class="deleteClass"
                  @click="
                    handleDelete(index, subIndex);
                    updateLocalStorage();
                  "
                />
              </td>
            </tr>
          </table>
        </li>
      </ul>
    </div>
    <div class="listBox" v-else>
      <ul>
        <li v-for="(item, index) in goodsList" :key="index">
          <h5>
            <input
              type="checkbox"
              class="checkboxClass"
              :checked="item.isCheck"
              @click="checkLiGoodsClick(index)"
            />
            <span>{{ item.theme }}</span
            ><img
              src="https://img.bbalt.cn/imgh5/donate/icon_narrow_right.svg"
              alt=""
            />
          </h5>
          <table>
            <tr v-for="(subItem, subIndex) in item.details" :key="subIndex">
              <td>
                <input
                  type="checkbox"
                  class="checkboxClass"
                  :checked="subItem.isCheck"
                  @click="checkGoodsClick(index, subIndex)"
                />
              </td>
              <td>{{ subItem.nameCn }}</td>
              <td>{{ subItem.goodsName }}</td>
              <td class="countBox">
                <img
                  src="https://img.bbalt.cn/imgh5/userCenter/icon_minus.svg"
                  alt=""
                  @click="
                    () => {
                      subItem.donateCount--;
                      handleCount(
                        index,
                        subIndex,
                        subItem.donateCount,
                        subItem.insufficiency
                      );
                      updateLocalStorage();
                    }
                  "
                />
                <input
                  type="tel"
                  class="numberboxClass"
                  v-model="subItem.donateCount"
                  @mousedown="
                    donateCount = subItem.donateCount;
                    updateLocalStorage();
                  "
                  @change="
                    handleCount(
                      index,
                      subIndex,
                      subItem.donateCount,
                      subItem.insufficiency
                    );
                    updateLocalStorage();
                  "
                />
                <img
                  src="https://img.bbalt.cn/imgh5/userCenter/icon_add.svg"
                  alt=""
                  @click="
                    subItem.donateCount++;
                    updateLocalStorage();
                    handleCount(
                      index,
                      subIndex,
                      subItem.donateCount,
                      subItem.insufficiency
                    );
                  "
                  :disabled="subItem.insufficiency === 0"
                  :class="subItem.insufficiency === 0 ? 'img-onlyRead' : ''"
                />
              </td>
              <td>
                <img
                  src="https://img.bbalt.cn/imgh5/userCenter/icon_delete.svg"
                  alt=""
                  class="deleteClass"
                  @click="
                    handleDelete(index, subIndex);
                    updateLocalStorage();
                  "
                />
              </td>
            </tr>
          </table>
        </li>
      </ul>
    </div>
    <div class="footBox" v-if="curSelectTab === '捐衣'">
      <div class="btnListBox">
        <span
          ><input
            type="checkbox"
            id="allCheck"
            :checked="isAllClothesCheck"
            @click="setAllClothesCheck"
          /><label for="allCheck">全选</label></span
        >
      </div>
      <button
        :class="curDataList.length === 0 ? 'grayClass' : 'buttonClass'"
        @click="handleClothes()"
        :disabled="curDataList.length === 0"
      >
        提交
      </button>
    </div>
    <div class="footBox" v-else>
      <div class="btnListBox">
        <span
          ><input
            type="checkbox"
            id="allCheck"
            :checked="isAllGoodsCheck"
            @click="setAllGoodsCheck()"
          /><label for="allCheck">全选</label></span
        >
      </div>
      <button
        :class="curDataList.length === 0 ? 'grayClass' : 'buttonClass'"
        @click="handleGoods()"
        :disabled="curDataList.length === 0"
      >
        提交
      </button>
    </div>
  </div>
</template>

<script>
import SelectTab from "@/components/SelectTab.vue";
import { fastDonate } from "@/api/donate.js";
export default {
  components: { SelectTab },
  props: ["donateType"],
  data() {
    return {
      curSelectTab: "捐衣",
      isAllClothesCheck: false,
      isAllGoodsCheck: false,
      clothesList: [],
      goodsList: [],
      curDataList: [],
      donateObj: [],
    };
  },
  created() {
    if (this.donateType === 1) {
      this.curSelectTab = "捐衣";
    } else {
      this.curSelectTab = "捐物";
    }
    this.getListData();
  },
  methods: {
    selectTab(item) {
      this.curSelectTab = item;
    },
    checkLiClothesClick(index) {
      this.clothesList[index].isCheck = !this.clothesList[index].isCheck;
      this.clothesList[index].isHalfCheck =
        !this.clothesList[index].isHalfCheck;
      this.clothesList[index].details = this.clothesList[index].details.map(
        (item) => {
          item.isCheck = this.clothesList[index].isCheck;
          return item;
        }
      );
      if (this.clothesList.every((item) => item.isCheck === true)) {
        this.isAllClothesCheck = true;
      } else {
        this.isAllClothesCheck = false;
      }
      this.setPostData(1);
    },
    checkLiGoodsClick(index) {
      this.goodsList[index].isCheck = !this.goodsList[index].isCheck;
      this.goodsList[index].isHalfCheck = !this.goodsList[index].isHalfCheck;
      this.goodsList[index].details = this.goodsList[index].details.map(
        (item) => {
          item.isCheck = this.goodsList[index].isCheck;
          return item;
        }
      );
      if (this.goodsList.every((item) => item.isCheck === true)) {
        this.isAllGoodsCheck = true;
      } else {
        this.isAllGoodsCheck = false;
      }
      this.setPostData(2);
    },
    setAllClothesCheck() {
      this.isAllClothesCheck = !this.isAllClothesCheck;
      this.clothesList = this.clothesList.map((item) => {
        item.isCheck = !item.isCheck;
        item.isHalfCheck = !item.isHalfCheck;
        item.details = item.details.map((subItem) => {
          subItem.isCheck = this.isAllClothesCheck;
          return subItem;
        });
        return item;
      });
      this.setPostData(1);
    },
    checkClothesClick(index, subIndex) {
      this.clothesList[index].details[subIndex].isCheck =
        !this.clothesList[index].details[subIndex].isCheck;
      if (
        this.clothesList[index].details.every((item) => item.isCheck === true)
      ) {
        this.clothesList[index].isCheck = true;
      } else {
        this.clothesList[index].isCheck = false;
      }
      if (
        this.clothesList[index].details.every((item) => item.isCheck === false)
      ) {
        this.clothesList[index].isHalfCheck = false;
      } else {
        this.clothesList[index].isHalfCheck = true;
      }
      if (this.clothesList.every((item) => item.isCheck === true)) {
        this.isAllClothesCheck = true;
      } else {
        this.isAllClothesCheck = false;
      }
      this.setPostData(1);
    },
    setAllGoodsCheck() {
      this.isAllGoodsCheck = !this.isAllGoodsCheck;

      this.goodsList = this.goodsList.map((item) => {
        item.isCheck = !item.isCheck;
        item.isHalfCheck = !item.isHalfCheck;
        item.details = item.details.map((subItem) => {
          subItem.isCheck = this.isAllGoodsCheck;
          return subItem;
        });
        return item;
      });
      this.setPostData(2);
    },
    checkGoodsClick(index, subIndex) {
      this.goodsList[index].details[subIndex].isCheck =
        !this.goodsList[index].details[subIndex].isCheck;

      if (
        this.goodsList[index].details.every((item) => item.isCheck === true)
      ) {
        this.goodsList[index].isCheck = true;
      } else {
        this.goodsList[index].isCheck = false;
      }
      if (
        this.goodsList[index].details.every((item) => item.isCheck === false)
      ) {
        this.goodsList[index].isHalfCheck = false;
      } else {
        this.goodsList[index].isHalfCheck = true;
      }
      if (this.goodsList.every((item) => item.isCheck === true)) {
        this.isAllGoodsCheck = true;
      } else {
        this.isAllGoodsCheck = false;
      }
      this.setPostData(2);
    },
    async handleGoods() {
      this.setPostData(2);
      const { code, content, message } = await fastDonate(this.curDataList);
      if (code === 200) {
        this.$toast.success("操作成功");
        this.$router.push({
          path: "/send",
          query: {
            code: content.code,
            dataList: JSON.stringify(this.donateObj),
            donateInfoId: content.donateInfoId,
            donateType:  2,
          },
        });
        this.updateData();
      } else {
        this.$toast.fail(message);
      }
    },
    async handleClothes() {
      this.setPostData(1);
      const { code, content, message } = await fastDonate(this.curDataList);
      if (code === 200) {
        this.$toast.success("操作成功");
        this.$router.push({
          path: "/send",
          query: {
            code: content.code,
            dataList: JSON.stringify(this.donateObj),
            donateInfoId: content.donateInfoId,
            donateType: 1,
          },
        });
        this.updateData();
      } else {
        this.$toast.fail(message);
      }
    },
    handleDelete(index, subIndex) {
      if (this.curSelectTab === "捐衣") {
        this.clothesList[index].details.splice(subIndex, 1);
        if (this.clothesList[index].details.length === 0) {
          this.clothesList.splice(index, 1);
        }
        this.updateLocalStorage();
      }

      if (this.curSelectTab === "捐物") {
        this.goodsList[index].details.splice(subIndex, 1);
        if (this.goodsList[index].details.length === 0) {
          this.goodsList.splice(index, 1);
        }
        this.updateLocalStorage();
      }
      if (this.clothesList.length === 0) {
        this.isAllClothesCheck = false;
      }
      if (this.goodsList.length === 0) {
        this.isAllGoodsCheck = false;
      }
    },
    getListData() {
      if (localStorage.getItem("donateClothes")) {
        JSON.parse(localStorage.getItem("donateClothes")).map((item) => {
          this.clothesList.push({
            id: item.id,
            theme: item.theme,
            isCheck: false,
            isHalfCheck: false,
            details: item.details
              .map((subItem1, subIndex1) => {
                item.details.map((subItem2, subIndex2) => {
                  if (subIndex1 != subIndex2 && subItem1.id == subItem2.id) {
                    subItem1.donateCount =
                      Number(subItem1.donateCount) +
                      Number(subItem2.donateCount);
                    subItem1.isCheck = false;
                    item.details.splice(subIndex2, 1);
                  }
                });
                return subItem1;
              })
              .filter((elm) => elm),
          });
        });
      }
      if (localStorage.getItem("donateGoods")) {
        JSON.parse(localStorage.getItem("donateGoods")).map((item) => {
          this.goodsList.push({
            id: item.id,
            theme: item.theme,
            isHalfCheck: false,
            details: item.details
              .map((subItem1, subIndex1) => {
                item.details.map((subItem2, subIndex2) => {
                  if (subIndex1 != subIndex2 && subItem1.id == subItem2.id) {
                    subItem1.donateCount =
                      Number(subItem1.donateCount) +
                      Number(subItem2.donateCount);
                    item.details.splice(subIndex2, 1);
                  }
                });
                return subItem1;
              })
              .filter((elm) => elm),
          });
        });
      }
    },
    setPostData(type) {
      this.curDataList = [];
      this.donateObj = [];

      if (type === 1) {
        this.clothesList.map((item) => {
          if (item.isCheck || item.isHalfCheck) {
            const selectedDetails = item.details.filter(
              (e) => e.isCheck && Number(e.donateCount) > 0
            );
            if (selectedDetails.length === 0) {
              return;
            }
            this.donateObj.push({
              theme: item.theme,
              list: selectedDetails.map((e) => {
                return {
                  sexName: e.sexName,
                  seasonName: e.seasonName,
                  donateCount: e.donateCount,
                  sizeHeightName: e.sizeHeightName,
                };
              }),
            });
            this.curDataList.push({
              id: item.id,
              type: type,
              demandCount: selectedDetails.reduce((acc, obj) => {
                return acc + Number(obj.donateCount);
              }, 0),
              details: selectedDetails.map((e) => {
                return { id: e.id, number: Number(e.donateCount) };
              }),
            });
          }
        });
      } else {
        this.goodsList.map((item) => {
          if (item.isCheck || item.isHalfCheck) {
            const selectedDetails = item.details.filter(
              (e) => e.isCheck && Number(e.donateCount) > 0
            );
            if (selectedDetails.length === 0) {
              return;
            }
            this.donateObj.push({
              theme: item.theme,
              list: selectedDetails.map((e) => {
                return {
                  sexName: e.sexName,
                  seasonName: e.seasonName,
                  donateCount: e.donateCount,
                  sizeHeightName: e.sizeHeightName,
                  goodsName: e.goodsName,
                  categoryName: e.categoryName,
                };
              }),
            });
            this.curDataList.push({
              id: item.id,
              type: type,
              demandCount: selectedDetails.reduce((acc, obj) => {
                return acc + Number(obj.donateCount);
              }, 0),
              details: selectedDetails.map((e) => {
                return { id: e.id, number: Number(e.donateCount) };
              }),
            });
          }
        });
      }
    },
    handleCount(index, subIndex, val, max) {
      if (this.curSelectTab === "捐衣") {
        if (val < 0 || !Number(val)) {
          this.clothesList[index].details[subIndex].donateCount = 0;
        }
        if (Number(val) > Number(max)) {
          this.clothesList[index].details[subIndex].donateCount = max;
        }
      } else {
        if (val < 0 || !Number(val)) {
          this.goodsList[index].details[subIndex].donateCount = 0;
        }
        if (Number(val) > Number(max)) {
          this.goodsList[index].details[subIndex].donateCount = max;
        }
      }
    },
    updateData() {
      let updateList = [];
      if (this.curSelectTab === "捐衣") {
        this.clothesList.map((item) => {
          if (!item.isCheck || !item.isHalfCheck) {
            updateList.push({
              id: item.id,
              theme: item.theme,
              details: item.details
                .map((e) => {
                  return !e.isCheck ? e : null;
                })
                .filter((elm) => elm),
            });
          }
        });
        this.clothesList = updateList;
        localStorage.setItem("donateClothes", JSON.stringify(updateList));
      }

      if (this.curSelectTab === "捐物") {
        this.goodsList.map((item) => {
          if (!item.isCheck || !item.isHalfCheck) {
            updateList.push({
              id: item.id,
              theme: item.theme,
              details: item.details
                .map((e) => {
                  return !e.isCheck ? e : null;
                })
                .filter((elm) => elm),
            });
          }
        });
        this.goodsList = updateList;
        localStorage.setItem("donateGoods", JSON.stringify(updateList));
      }
    },
    updateLocalStorage() {
      if (this.curSelectTab === "捐衣") {
        localStorage.setItem("donateClothes", JSON.stringify(this.clothesList));
      }
      if (this.curSelectTab === "捐物") {
        localStorage.setItem("donateGoods", JSON.stringify(this.goodsList));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.backetWrap {
  background-color: #fff;
  font-family: PingFangSC, PingFang SC;
  overflow: hidden;
  height: calc(100% - 37px);
  padding-bottom: 37px;
  margin-top: 96px;
  .nameClass {
    width: 100%;
    height: 96px;
    font-size: 36px;
    font-weight: 400;
    color: #333333;
    line-height: 96px;
    text-align: center;
    background-image: url("https://img.bbalt.cn/imgh5/donate/icon_help.svg");
    background-repeat: no-repeat;
    background-size: 30px 30px;
    background-position: 96% 37px;
    background-color: #fff;
  }
  ::v-deep .selectTabBox {
    li {
      width: 50%;
    }
  }
  .listBox {
    height: 72%;
    overflow: auto;
    width: 100%;
    background-color: #f5f5f5;
    ul {
      margin: 16px;
      width: auto;
      li {
        height: 600px;
        background: #ffffff;
        border-radius: 24px;
        margin-bottom: 16px;
        padding: 36px 32px;
        overflow: hidden;
        h5 {
          font-size: 30px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 40px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 40px;
          span {
            display: inline-block;
            width: 85%;
            text-align: left;
            margin-left: 32px;
          }
          img {
            height: 30px;
            width: 30px;
          }
        }
        table {
          width: 100%;
          overflow: auto;
          height: 480px;
          display: inline-block;
          tr {
            height: 120px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            font-size: 26px;
            font-weight: 400;
            color: #333333;
            line-height: 34px;

            td {
              min-width: 100px;
              text-align: left;
              &:first-child,
              &:last-child {
                min-width: auto;
              }
            }
            .deleteClass {
              width: 30px;
              height: 30px;
            }
          }
        }
      }
    }
  }
  .footBox {
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 220px;
    background: #ffffff;
    box-shadow: 0px -1px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 0px 0px 16px 16px;
    display: flex;
    justify-content: space-between;
    .buttonClass {
      width: 304px;
      height: 88px;
      background: #fe66a6;
      box-shadow: 0px -1px 16px 0px rgba(0, 0, 0, 0.08);
      border-radius: 47px;
      border: none;
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 88px;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
      margin-top: 16px;
      margin-right: 32px;
    }
    .grayClass {
      background: gray;
      width: 304px;
      height: 88px;
      box-shadow: 0px -1px 16px 0px rgba(0, 0, 0, 0.08);
      border-radius: 47px;
      border: none;
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 88px;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
      margin-top: 16px;
      margin-right: 32px;
    }
    .btnListBox {
      display: flex;
      font-size: 28px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
      margin-left: 64px;
      height: 80px;
      margin-top: 16px;
      input {
        margin-right: 24px;
      }
      span {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &.beilanClass {
        margin-left: 22px;
        color: #666666;
        font-size: 24px;
        input {
          margin-right: 0px;
          margin-bottom: 8px;
        }
        span {
          flex-flow: column;
          width: 96px;
          margin-right: 12px;
        }
        img {
          margin-bottom: 8px;
          width: 40px;
          height: 40px;
        }
      }
    }
  }
  .countBox {
    width: 164px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
    }
    .numberboxClass {
      width: 56px;
      height: 36px;
      background: #f5f5f5;
      border-radius: 2px;
      border: none;
      text-align: center;

      color: #333333;
    }
  }
}
</style>
